import { getService, postService } from '../api/service.js'
// 获取验证码

export const getCaptcha = params =>{ 
  return postService('api/auth/getCaptcha', params)
}
// 登录

export const distributorTwoLogin = params =>{ 
  return postService('api/distributortwo/distributorTwoLogin', params)
}
// 退出登录
export const distributorTwoLogout = params =>{ 
  return postService('api/distributortwo/distributorTwoLogout', params)
}

// 刷新token

export const distributorTwoRefresh = params =>{ 
  return postService('api/distributortwo/distributorTwoRefresh', params)
}

// 订单管理

export const getDistributorTwoOrderList = params =>{ 
  return postService('api/distributortwo/getDistributorTwoOrderList', params)
}
// 订单退票
export const distributorTwoRefund = params =>{ 
  return postService('api/distributortwo/distributorTwoRefund', params)
}
// 重发短信
export const sendDistributorTwoOrderMsg = params =>{ 
  return postService('api/distributortwo/sendDistributorTwoOrderMsg', params)
}
// 景区列表

export const getDistributorTwoScenicList = params =>{ 
  return postService('api/distributortwo/getDistributorTwoScenicList', params)
}
// 导出列表

export const distributorTwoPostExport = params =>{ 
  return postService('api/distributortwo/distributorTwoPostExport', params)
}

// 系统设置 基本信息

export const getDistributorTwoInfo = params =>{ 
  return postService('api/distributortwo/getDistributorTwoInfo', params)
}
// 接口配置

export const setDistributorTwoApi = params =>{ 
  return postService('api/distributortwo/setDistributorTwoApi', params)
}
// 管理员列表

export const getUserInfoTwoList = params =>{ 
  return postService('api/distributortwo/getUserInfoTwoList', params)
}
// 管理员添加

export const addUserInfoTwo = params =>{ 
  return postService('api/distributortwo/addUserInfoTwo', params)
}
// 删除管理员

export const getUserInfoTwoDelete = params =>{ 
  return postService('api/distributortwo/getUserInfoTwoDelete', params)
}
// 管理员详情

export const getUserInfoTwoInfo = params =>{ 
  return postService('api/distributortwo/getUserInfoTwoInfo', params)
}
// 修改管理员

export const getUserInfoTwoUpdate = params =>{ 
  return postService('api/distributortwo/getUserInfoTwoUpdate', params)
}

// 角色列表

export const getDisAuthGroupTwoList = params =>{ 
  return postService('api/distributortwo/getDisAuthGroupTwoList', params)
}
// 添加角色

export const addDisAuthGroupTwo = params =>{ 
  return postService('api/distributortwo/addDisAuthGroupTwo', params)
}
// 修改角色

export const updateDisAuthGroupTwo = params =>{ 
  return postService('api/distributortwo/updateDisAuthGroupTwo', params)
}

// 删除角色

export const deleteDisAuthGroupTwo = params =>{ 
  return postService('api/distributortwo/deleteDisAuthGroupTwo', params)
}
// 权限列表

export const getDisAuthRuleTwoList = params =>{ 
  return postService('api/distributortwo/getDisAuthRuleTwoList', params)
}

// 权限设置

export const addDisAuthGroupTwoAndRuleTwo = params =>{ 
  return postService('api/distributortwo/addDisAuthGroupTwoAndRuleTwo', params)
}
// 修改密码

export const updatePwd = params =>{ 
  return postService('api/distributortwo/updatePwd', params)
}

// 销售订单

export const getDistributorTwoSalesOrderList = params =>{ 
  return postService('api/distributortwo/getDistributorTwoSalesOrderList', params)
}
// 导出销售订单

export const distributorTwoSalesOrderExport = params =>{ 
  return postService('api/distributortwo/distributorTwoSalesOrderExport', params)
}
// 消费统计列表
export const getDistributorTwoConsumeOrderList = params =>{ 
  return postService('api/distributortwo/getDistributorTwoConsumeOrderList', params)
}
// 消费导出
export const distributorTwoConsumeOrderExcel = params =>{ 
  return postService('api/distributortwo/distributorTwoConsumeOrderExcel', params)
}


// 退款列表

export const getDistributorTwoRefundOrderList = params =>{ 
  return postService('api/distributortwo/getDistributorTwoRefundOrderList', params)
}
// 退款导出
export const distributorTwoRefundOrderExcel = params =>{ 
  return postService('api/distributortwo/distributorTwoRefundOrderExcel', params)
}


// 上级分销商
export const getParentDistributorList = params =>{ 
  return postService('api/distributortwo/getParentDistributorList', params)
}

// 上级分销商详情
export const getParentDistributorInfo = params =>{ 
  return postService('api/distributortwo/getParentDistributorInfo', params)
}
// 产品列表
export const getDistributorTwoGoodsList = params =>{ 
  return postService('api/distributortwo/getDistributorTwoGoodsList', params)
}
// 购买

export const addDistributorTwoOrder = params =>{ 
  return postService('api/distributortwo/addDistributorTwoOrder', params)
}
// 产品详情

export const getProductTwo = params =>{ 
  return postService('api/distributortwo/getProductTwo', params)
}
// 商品类型

export const getProductNewTypeList = params =>{ 
  return postService('api/product/getProductNewTypeList', params)
}

// 商品日历

export const getProductCldTwo = params =>{ 
  return postService('api/distributortwo/getProductCldTwo', params)
}

export const getDistributorTwoOrderInfo = params =>{ 
  return postService('api/distributortwo/getDistributorTwoOrderInfo', params)
}